// TODO remove when the promotional period ends
import Theme from '@jetbrains/ring-ui/components/global/theme'
import Select from '@jetbrains/ring-ui/components/select/select'

import {setGlobalTheme} from '../../../../actions/theme'
import {useUserTheme} from '../../../../hooks/theme/useUserTheme'
import {useSetUserProperty} from '../../../../hooks/useSetUserProperty'
import {UserProperties} from '../../../../utils/userProperties'

import styles from './TemporaryPromotionalThemeSwitcher.css'

export function TemporaryPromotionalThemeSwitcher() {
  const theme = useUserTheme()
  const items = [
    {label: 'Light', selectedLabel: 'Theme: Light', key: Theme.LIGHT},
    {label: 'Dark', selectedLabel: 'Theme: Dark', key: Theme.DARK},
    {label: 'System theme', selectedLabel: 'Theme: System', key: Theme.AUTO},
  ]
  const setUserProperty = useSetUserProperty()
  return (
    <Select
      className={styles.select}
      buttonClassName={styles.button}
      type={Select.Type.INLINE}
      data={items}
      label="Choose Theme"
      selected={items.find(item => item.key === theme)}
      onSelect={item => {
        if (item != null) {
          setUserProperty(UserProperties.THEME, item.key)
          setGlobalTheme(item.key)
        }
      }}
    />
  )
}

export default TemporaryPromotionalThemeSwitcher
